import { component as defineComponent } from 'flightjs';
import EmailSubscriptionService from '@99designs/common/utils/platform/emailSubscriptionService';

function BriefEmailBeforeSignupField() {
    this.attributes({
        email: '[data-email-before-signup-field]',
        contactCheckbox: '[data-contactable-agreement]',
        broadcastEvent: 'uiBriefEmailBeforeSignupChanged',
    });

    this.subscribe = function(e) {
        const $email = this.select('email');
        // Check if the checkbox was rendered.  If it wasn't then we automatically signup.
        const subscribeToMarketing = this.select('contactCheckbox').length
            ? this.select('contactCheckbox')[0].checked
            : true;

        const emailService = new EmailSubscriptionService(window.analytics);
        emailService.subscribe({
            email: $email.val(),
            acquisitionSource: 'launch',
            subscribeToMarketing,
            customData: {
                draft_id: $email.attr('data-draft-id'),
                category_key: $email.attr('data-category-key'),
            },
        });
    };

    this.broadcastAction = function(e) {
        this.trigger(this.attr.broadcastEvent, {
            value: e.target.value,
        });
    };

    this.after('initialize', function() {
        this.on('change', this.subscribe);
        this.on('change', this.broadcastAction);
    });
}

export default defineComponent(BriefEmailBeforeSignupField);



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/brief-email-before-signup-field.js